module.exports = __webpack_public_path__ + "static/media/endless-clouds.aeb0def0.svg";